import React from "react";
import { statusTone } from "@/lib/format";

const TONES = {
  green: "bg-[#E0EFEA] text-[#087A73] border-[#087A73]/30",
  yellow: "bg-[#FBF0D6] text-[#8a6400] border-[#D99A00]/40",
  red: "bg-[#F9E3E0] text-[#C0392B] border-[#C0392B]/30",
  gray: "bg-[#EAF3EF] text-[#5C6B68] border-[#D2E3DB]",
};

export function StatusBadge({ status, label, testid }) {
  const tone = TONES[statusTone(status)] || TONES.gray;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold whitespace-nowrap ${tone}`}
    >
      {label || status}
    </span>
  );
}
